import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "../lib/adminAuth";

export default function AdminProtected({ children }) {
  if (!getToken()) return <Navigate to="/admin/login" replace />;
  return children;
}
